/* MTN : comportements du thème Branding */
(function(){
  function initCard(card){
    if(card.dataset.mtnInit) return; card.dataset.mtnInit='1';
    var slides=[].slice.call(card.querySelectorAll('.mtn-card__slide'));
    var dots=[].slice.call(card.querySelectorAll('.mtn-card__dots span'));
    var video=card.querySelector('video.mtn-card__video');
    var i=0, fine=window.matchMedia('(hover:hover)').matches;
    function show(n){ if(!slides.length) return; i=(n+slides.length)%slides.length;
      slides.forEach(function(s,k){s.classList.toggle('is-active',k===i); if(k===i){var im=s.querySelector('img[data-src]'); if(im){im.src=im.dataset.src; if(im.dataset.srcset) im.srcset=im.dataset.srcset; im.removeAttribute('data-src');}}});
      dots.forEach(function(d,k){d.classList.toggle('is-active',k===i)}); }
    function stop(e){e.preventDefault();e.stopPropagation();}
    var p=card.querySelector('.mtn-card__arrow--prev'), n=card.querySelector('.mtn-card__arrow--next');
    if(p) p.addEventListener('click',function(e){stop(e);show(i-1)});
    if(n) n.addEventListener('click',function(e){stop(e);show(i+1)});
    card.addEventListener('pointerenter',function(e){ if(e.pointerType!=='mouse') return;
      if(video){ if(!video.src && video.dataset.src){video.src=video.dataset.src;} var pr=video.play(); if(pr&&pr.catch) pr.catch(function(){}); card.classList.add('is-playing'); }
      else if(slides.length>1){ show(1); } });
    card.addEventListener('pointerleave',function(e){ if(e.pointerType!=='mouse') return;
      if(video){ video.pause(); card.classList.remove('is-playing'); try{video.currentTime=0}catch(x){} }
      show(0); });
    var x0=null;
    card.addEventListener('touchstart',function(e){x0=e.touches[0].clientX},{passive:true});
    card.addEventListener('touchend',function(e){ if(x0===null) return; var dx=e.changedTouches[0].clientX-x0; x0=null;
      if(Math.abs(dx)>40){ show(i+(dx<0?1:-1)); card.dataset.swiped='1'; setTimeout(function(){delete card.dataset.swiped},350);} },{passive:true});
    card.addEventListener('click',function(e){ if(card.dataset.swiped){e.preventDefault();} });
  }
  function initGuide(g){
    if(g.dataset.mtnInit) return; g.dataset.mtnInit='1';
    var opts=[].slice.call(g.querySelectorAll('[data-guide-opt]')), panes=[].slice.call(g.querySelectorAll('[data-guide-pane]'));
    function pick(k){ opts.forEach(function(o){o.classList.toggle('is-active',o.dataset.guideOpt===k); o.setAttribute('aria-pressed',o.dataset.guideOpt===k)});
      panes.forEach(function(p){p.hidden=p.dataset.guidePane!==k}); }
    opts.forEach(function(o){o.addEventListener('click',function(){pick(o.dataset.guideOpt)})});
    if(opts[0]) pick(opts[0].dataset.guideOpt);
  }
  function init(root){
    root=root||document;
    root.querySelectorAll('.mtn-card').forEach(initCard);
    root.querySelectorAll('[data-mtn-guide]').forEach(initGuide);
    var els=root.querySelectorAll('.mtn-reveal:not(.is-in)');
    if('IntersectionObserver' in window){ var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){x.target.classList.add('is-in');io.unobserve(x.target)}})},{rootMargin:'0px 0px -8% 0px'}); els.forEach(function(el){io.observe(el)}); }
    else els.forEach(function(el){el.classList.add('is-in')});
    root.querySelectorAll('video[data-mtn-autopause]').forEach(function(v){ if(!('IntersectionObserver' in window)) return;
      new IntersectionObserver(function(en){en.forEach(function(x){ if(x.isIntersecting){var pr=v.play(); if(pr&&pr.catch) pr.catch(function(){});} else v.pause(); })}).observe(v); });
  }
  if(document.readyState!=='loading') init(); else document.addEventListener('DOMContentLoaded',function(){init()});
  document.addEventListener('shopify:section:load',function(e){init(e.target)});
})();